import type { CatalogState } from './catalogSlice.types';

export const INITIAL_CATALOG_STATE: CatalogState = {
  orderPreview: null,
  orderConfirmationDetails: null,
  deviceOrderConfirmation: null,
  isEditPaymentModalOpen: false,
  pendingDiscount: null,
  deviceOrderPreview: null,
};
